import * as React from "react";
import { useState } from "react";
import { APP_CONFIG } from "../constants/authConfig";
import Spinner from "./ui/Spinner";

export default function WelcomePage({
  onSignIn,
  isSubmitting,
  error,
  isChangingEmail = false,
  remainingEmailChanges = APP_CONFIG.maxEmailChanges,
}) {
  const [email, setEmail] = useState("");

  const handleSubmit = async (event) => {
    event.preventDefault();
    await onSignIn(email, { isEmailChange: isChangingEmail });
  };

  return (
    <div className="min-h-screen w-full bg-[radial-gradient(circle_at_top,#dbeafe_0%,#f8fafc_28%,#e2e8f0_100%)]">
      <div className="flex w-full flex-col gap-2">
        <section className="overflow-hidden border-b border-white/60 bg-gradient-to-br from-slate-950 via-slate-900 to-brand-700 px-3 py-3 text-white shadow-lg">
          <div className="flex items-center gap-2.5">
            <img
              src="assets/icon-80.png"
              alt={APP_CONFIG.name}
              className="h-9 w-9 shrink-0 rounded-lg ring-1 ring-white/15"
            />
            <div>
              <h1 className="text-sm font-semibold tracking-tight">{APP_CONFIG.name}</h1>
              <p className="text-xs text-slate-300">XML to Excel column parser</p>
            </div>
          </div>
        </section>

        <section className="card space-y-4 !rounded-none !border-x-0">
          <div>
            <p className="eyebrow">{isChangingEmail ? "Change email" : "Get started"}</p>
            <h2 className="mt-1 text-base font-semibold tracking-tight text-slate-950">
              {isChangingEmail ? "Enter your new email" : "Enter your email"}
            </h2>
            <p className="mt-2 section-hint">
              {isChangingEmail
                ? `${remainingEmailChanges} email change(s) remaining.`
                : "New users get 1 month free."}
            </p>
          </div>

          <form className="space-y-3" onSubmit={handleSubmit}>
            <div className="space-y-1.5">
              <label htmlFor="email" className="text-xs font-medium text-slate-600">
                Email address
              </label>
              <input
                id="email"
                type="email"
                autoComplete="email"
                className="input-field"
                placeholder="you@example.com"
                value={email}
                disabled={isSubmitting}
                onChange={(event) => setEmail(event.target.value)}
              />
            </div>

            {error && (
              <div className="rounded-xl border border-red-200 bg-red-50 px-3 py-2 text-sm text-red-800">
                {error}
              </div>
            )}

            <button type="submit" className="btn-primary" disabled={isSubmitting}>
              {isSubmitting ? (
                <>
                  <Spinner />
                  Checking subscription...
                </>
              ) : (
                "Continue"
              )}
            </button>
          </form>

          <p className="text-[11px] leading-4 text-slate-500">
            Support:{" "}
            <a href={`mailto:${APP_CONFIG.supportEmail}`} className="text-brand-700 underline">
              {APP_CONFIG.supportEmail}
            </a>
          </p>
        </section>
      </div>
    </div>
  );
}
